import { api } from '../AxiosConfig';

class NotificationsService {
    getAll(params?: { page?: number; limit?: number; onlyNotVisualized?: boolean }) {
        return api.get('notifications/getAll', { params });
    }

    getCount() {
        return api.get('notifications/count');
    }

    viewAll() {
        return api.post('notifications/viewAll');
    }

    view(_id: string) {
        return api.post('notifications/view', { _id });
    }

    removeAll() {
        return api.post('notifications/removeAll');
    }
}

export { NotificationsService };
